import { $getRoot, $getSelection, ElementNode, LexicalEditor } from "lexical";
import { useMemo, useState } from "react";

export const useSkedEditor = () => {
  const [editor, setEditor] = useState<LexicalEditor>();
  return [
    useMemo(
      () => ({
        insertText(text: string) {
          editor?.update(() => {
            const selection = $getSelection() || $getRoot().selectStart();
            selection.insertText(text);
          });
        },
        setContent(text: string, convertFunc: (text: string) => ElementNode) {
          editor?.update(() => {
            const root = $getRoot();
            root.clear();
            root.append(convertFunc(text));
          });
        },
        clear() {
          editor?.update(() => {
            const root = $getRoot();
            root.clear();
          });
        },
        focus() {
          editor?.focus();
        },
        lexicalEditor() {
          return editor;
        },
      }),
      [editor]
    ),
    (params: { editor: LexicalEditor }) => setEditor(params.editor),
  ] as const;
};
